import { addDays, floorDate } from 'utils/dates';

export const useServiceSlotsConfig = () => {
    const maxDaysRangeSize = 5;
    const initDateFrom = floorDate(new Date());
    const initFetchedDateTo = addDays(initDateFrom, maxDaysRangeSize * 2);

    return { maxDaysRangeSize, initDateFrom, initFetchedDateTo };
};
